import React from "react";
import ReactDOM from "react-dom";
import { Router, browserHistory } from "react-router";
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap/dist/css/bootstrap-theme.css";
// import "./css/bootstrap.css";
// import "./css/bootstrap-theme.css";
import "./css/bootstrap.min.css";
import "./index.css";

const rootRoute = {
  childRoutes: [
    {
      path: "/",
      indexRoute: require("./routes/Home"),
      component: require("./components/App"),
      childRoutes: [
        require("./routes/About"),
        require("./routes/History"),
        require("./routes/Pictures"),
        require("./routes/Weather"),
        require("./routes/SoilMoisture"),
        require("./routes/Contact")
      ]
    }
  ]
};

ReactDOM.render(
  <Router history={browserHistory} routes={rootRoute} />,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js